import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { CodeStyle } from 'utils/code';

class BackendTesting extends Component {

    render() {

        return (
            <>

            <Container>

                <Helmet>
                    <title>Testing</title>
                    <meta name="description" content="Testing" />
                </Helmet>

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers/development/backend" 
                    title={<span>Development</span>} breadcrumb_1="Backend"  breadcrumb_2="Testing" 
                />
                
                <Card>
                    <CardHeader>
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">Testing</h3>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>

                        <h4>If it's not tested it's not written</h4>
                        <p className="text-sm">
                            There are very few projects where testing is not an option. Unless specifically told all backend code written should have a test to go along with it.<br />
                            This test should share the same name as the file it is written for with test.js appended to it.

                            <hr />
                                <h4>Example</h4>
                                <p className="text-sm">
                                    File: authorizedTokenSent.js<br />
                                    Test: authorizedTokenSent.test.js
                                </p>
                            <hr />
                        </p>
                        <p className="text-sm">
                            Every function requires different types of testing however below you will find an example test written to update a users password. Use this to model any newly created tests after.
                        </p>


                      
<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{`const assert = require('assert');
const Axios = require('axios');
const keys = require('../../../../keys');

const mongoose = require('mongoose');

const test_collection = 'users';

mongoose.set('useFindAndModify', false);
mongoose.set('useNewUrlParser', true);
mongoose.set('useUnifiedTopology', true);

require('../../../models/_core/users')

let test_created_user = null

describe('/api/v1/auth/password_update', async function() {


    before(async function() {
        return new Promise(async resolve => {
               
            const call = await Axios({
                headers: {
                    authorization: \`Bearer \${keys.SYSTEM_API_KEY}\`
                },
                method: 'post',
                url: \`\${keys.SERVER_URL}/api/v1/auth/create_account\`,
                data: {
                    given_name: 'John',
                    family_name: 'Maher',
                    email: 'testingapiv1authpassword_update@gmail.com',
                    password: 'aaaaaa',
                    password_confirm: 'aaaaaa',
                }
            })

            test_created_user = call.data.user

            resolve()

        })
    });

    //delete all from collection after
    after(async function() {
        mongoose.connect(keys.MONGODB_URI, () => {
            mongoose.model(test_collection).deleteMany({email: ['testingapiv1authpassword_update@gmail.com']}, () => {
                //callback needs to fire to successfully delete documents here
            });
        })
    });

    it('should return a format error if the authorization header is not given', async function() {
           
        const call = await Axios({
            headers: {
                authorization: null
            },
            method: 'post',
           url: \`\${keys.SERVER_URL}/api/v1/auth/password_update\`,
        })

        assert.equal(call.data.success, false)
        assert.equal(call.data.message, 'Your authorization header was formatted incorrectly')

    });

    it('should return a format error if the authorization header does not include space', async function() {
       
        const call = await Axios({
            headers: {
                authorization: \`Bearer\${keys.SYSTEM_API_KEY}\`
            },
            method: 'post',
           url: \`\${keys.SERVER_URL}/api/v1/auth/password_update\`,
        })

        assert.equal(call.data.success, false)
        assert.equal(call.data.message, 'Your authorization header was formatted incorrectly')

    });

    it('should return success.true if updated successfully', async function() {

         //create a test user
         const call = await Axios({
            headers: {
                authorization: \`Bearer \${keys.SYSTEM_API_KEY}\`
            },
            method: 'post',
            url: \`\${keys.SERVER_URL}/api/v1/auth/password_update\`,
            data: {
                _id: test_created_user._id ,
                password: 'aaaaaab',
                password_confirm: 'aaaaaab',
            }
        })

        assert.equal(call.data.success, true)

    });

    it('should return success.false and a message if no _id id given', async function() {
       
         //create a test user
         const call = await Axios({
            headers: {
                authorization: \`Bearer \${keys.SYSTEM_API_KEY}\`
            },
            method: 'post',
            url: \`\${keys.SERVER_URL}/api/v1/auth/password_update\`,
            data: {
                _id: null ,
                password: 'aaaaaab',
                password_confirm: 'aaaaaab',
            }
        })

        assert.equal(call.data.success, false)
        assert.notEqual(call.data.message, null)

   });

    it('should return success.false and a message if a wrong id was given', async function() {
        
        //create a test user
        const call = await Axios({
            headers: {
                authorization: \`Bearer \${keys.SYSTEM_API_KEY}\`
            },
            method: 'post',
            url: \`\${keys.SERVER_URL}/api/v1/auth/password_update\`,
            data: {
                _id: 'jdhdhdhgdgh' ,
                password: 'aaaaaab',
                password_confirm: 'aaaaaab',
            }
        })

        assert.equal(call.data.success, false)
        assert.notEqual(call.data.message, null)

    });


    it('should return success.false and a message if a password was given that is too short', async function() {


        //create a test user
        const call = await Axios({
            headers: {
                authorization: \`Bearer \${keys.SYSTEM_API_KEY}\`
            },
            method: 'post',
            url: \`\${keys.SERVER_URL}/api/v1/auth/password_update\`,
            data: {
                _id: 'jdhdhdhgdgh' ,
                password: 'aa',
                password_confirm: 'aa',
            }
        })

        assert.equal(call.data.success, false)
        assert.notEqual(call.data.message, null)

    });

    it('should return success.false and a message if a passwords dont match', async function() {

        //create a test user
        const call = await Axios({
            headers: {
                authorization: \`Bearer \${keys.SYSTEM_API_KEY}\`
            },
            method: 'post',
            url: \`\${keys.SERVER_URL}/api/v1/auth/password_update\`,
            data: {
                _id: 'jdhdhdhgdgh' ,
                password: 'aaaaaaaaa',
                password_confirm: 'bbbbbb',
            }
        })

        assert.equal(call.data.success, false)
        assert.notEqual(call.data.message, null)

    });

    it('should return success.false and a message if no password is given', async function() {
        
        //create a test user
        const call = await Axios({
            headers: {
                authorization: \`Bearer \${keys.SYSTEM_API_KEY}\`
            },
            method: 'post',
            url: \`\${keys.SERVER_URL}/api/v1/auth/password_update\`,
            data: {
                _id: 'jdhdhdhgdgh' ,
                password: null,
                password_confirm: 'bbbbbb',
            }
        })

        assert.equal(call.data.success, false)
        assert.notEqual(call.data.message, null)

    });

    it('should return success.false and a message if no password_confirm is given', async function() {
        
        //create a test user
        const call = await Axios({
            headers: {
                authorization: \`Bearer \${keys.SYSTEM_API_KEY}\`
            },
            method: 'post',
            url: \`\${keys.SERVER_URL}/api/v1/auth/password_update\`,
            data: {
                _id: 'jdhdhdhgdgh' ,
                password: 'aaaaaaaaa',
                password_confirm: null,
            }
        })

        assert.equal(call.data.success, false)
        assert.notEqual(call.data.message, null)

    });

})
`}
</SyntaxHighlighter>    
 

                    
                    </CardBody>
                </Card>
          
            </Container>
            </>
        );
    }
}

export default BackendTesting